import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { ReactSVG } from "react-svg"

import { code_snippet_container, copy_icon, text_is_primary } from "./styles.module.scss"

// ---------------------------------------------------------

const CodeSnippet = ({ codeSnippet }) => {
  const [linkCopied, setLinkCopied] = useState(false)
  const primaryKeywords = ["install"]

  // -------------------------------------------------------

  const copyToClipboard = () => {
    setLinkCopied(true)
    navigator.clipboard.writeText(codeSnippet)
  }

  useEffect(() => {
    const timeout = setTimeout(() => setLinkCopied(false), 2000)
    return () => clearTimeout(timeout)
  }, [linkCopied])

  return (
    <div className={code_snippet_container}>
      {codeSnippet.split(" ").map((word, index) => {
        const isPrimaryKeyword = primaryKeywords.includes(word)
        return (
          <code key={index} className={isPrimaryKeyword ? text_is_primary : ""}>
            {word}{" "}
          </code>
        )
      })}
      <button
        aria-label={linkCopied ? "Copied!" : "Copy code"}
        onClick={copyToClipboard}
        className={copy_icon}
      >
        <ReactSVG src={linkCopied ? "/icons/check-solid.svg" : "/icons/copy-regular.svg"} />
      </button>
    </div>
  )
}

CodeSnippet.propTypes = {
  /**
   * Specifies the line of code to display
   */
  codeSnippet: PropTypes.string
}

export default CodeSnippet
